"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrokenHeart = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const BrokenHeart = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9868 9.08288L11.6818 5.61162L11.6635 5.4035C10.7434 4.53246 9.51162 4 8.15813 4C5.30937 4 3 6.35878 3 9.26849C3 10.9546 3.77548 12.4557 4.98202 13.4201L11.8939 20L11.3572 15.7746L12.0119 13.8122L11.3572 10.5414L12.0119 9.23315L11.9868 9.08288ZM19.5333 12.9479C20.4408 11.9984 21 10.7001 21 9.26849C21 6.35878 18.69 4 15.8405 4C14.4619 4 13.2095 4.72556 12.284 5.6584C12.284 5.62284 12.4283 5.97942 12.6314 6.49894C13.1131 7.73085 13.9254 9.87893 13.9286 9.88729L13.9286 9.8873L12.6429 11.8498L13.2857 13.8122L12 15.7746L12.3415 20L19.5355 12.95L19.5333 12.9479Z"
    })
  });
};
exports.BrokenHeart = BrokenHeart;